import { render, staticRenderFns } from "./SocialMediaHouseRules.vue?vue&type=template&id=41263361&"
import script from "./SocialMediaHouseRules.vue?vue&type=script&lang=js&"
export * from "./SocialMediaHouseRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports